export function Aggressive(props: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={props.className}
    >
      <path
        d="M2.4375 2.4375V15.4375C2.4375 15.8685 2.6087 16.2818 2.91345 16.5865C3.2182 16.8913 3.63152 17.0625 4.0625 17.0625H17.0625"
        stroke="#C2410C"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4766 7.69937C17.2542 6.35337 16.5502 4.92962 16.3306 4.42258C16.2941 4.33611 16.226 4.2675 16.1403 4.23064C16.0545 4.19378 15.9575 4.19142 15.8688 4.22406C14.8989 4.5773 13.5091 5.44338 12.6436 6.01369"
        stroke="#C2410C"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.32983 13.7248C12.0267 12.9625 13.9014 10.442 15.6545 5.19309"
        stroke="#C2410C"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  );
}
